import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type TruckIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const TruckIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: TruckIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.704 18.2958C19.323 18.9148 19.323 19.9178 18.704 20.5358C18.085 21.1548 17.082 21.1548 16.464 20.5358C15.845 19.9168 15.845 18.9138 16.464 18.2958C17.083 17.6768 18.086 17.6768 18.704 18.2958"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.704 18.2959C8.323 18.9149 8.323 19.9179 7.704 20.5359C7.085 21.1549 6.082 21.1549 5.464 20.5359C4.846 19.9169 4.845 18.9139 5.464 18.2959C6.083 17.6779 7.085 17.6769 7.704 18.2959"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4H14C14.552 4 15 4.448 15 5V15H2"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19.416H3C2.448 19.416 2 18.968 2 18.416V13"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7H19.323C19.732 7 20.1 7.249 20.251 7.629L21.857 11.643C21.951 11.879 22 12.131 22 12.385V18.333C22 18.885 21.552 19.333 21 19.333H19.169"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 19.4199H8.17"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 14H18V10H21.2"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4H7"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7H5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10H2"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
